import DataService from "@/services/DataService.js";
import genderModel from "@/models/gender";
import shoeSizeModel from "@/models/shoeSize";
import sizeModel from "@/models/size";
import weightModel from "@/models/weight";
import map from "lodash/map";

export const namespaced = true;

export const state = {
    shoeSizes: [],
    sizes: [],
    weights: []
};

export const mutations = {
    SET_GENDERS(state, genders) {
        state.genders = map(genders.items, gender => {
            const _g = new genderModel();
            _g.hydrate(gender);

            return _g;
        });
    },
    SET_SHOE_SIZES(state, shoeSizes) {
        state.shoeSizes = map(shoeSizes.items, shoeSize => {
            const _s = new shoeSizeModel();
            _s.hydrate(shoeSize);

            return _s;
        });
    },
    SET_SIZES(state, sizes) {
        state.sizes = map(sizes.items, size => {
            const _s = new sizeModel();
            _s.hydrate(size);

            return _s;
        });
    },
    SET_WEIGHTS(state, weights) {
        state.weights = map(weights.items, weight => {
            const _w = new weightModel();
            _w.hydrate(weight);

            return _w;
        });
    },
};

export const actions = {
    fetchData({commit}) {
        return DataService
            .getData()
            .then(({data}) => {
                commit("SET_SHOE_SIZES", data['shoe_sizes']);
                commit("SET_SIZES", data['sizes']);
                commit("SET_WEIGHTS", data['weights']);
                commit("SET_GENDERS", data['genders']);
            });
    }
};

export const getters = {
    getShoeSizeById: state => id => {
        return state.shoeSizes.find(shoeSize => shoeSize.id === id);
    },

    getSizeById: state => id => {
        return state.sizes.find(size => size.id === id);
    }
};
